import styled from 'styled-components';
import me from '../me.jpg';
import { description, name } from '../constants';

const About = () => {
  return (
    <Section>
      <div className="left">
        <img src={me} alt={name} />
      </div>
      <div className="right">
        <h1>About Me</h1>
        <h2>Hi, I'm {name} 👋</h2>
        <p>{description}</p>
      </div>
    </Section>
  );
};

export default About;

const Section = styled.section`
  display: flex;
  padding: 3rem 0;
  padding-right: 0;
  padding-left: 10vw;
  @media screen and (max-width: 1110px) {
    flex-direction: column-reverse;
    align-items: center;
    padding-left: 0; 
  };
  .left {
    height: 100%;
    img {
      filter: grayscale(100%) brightness(0.8);
      width: 100%;
      max-width: 570px;
      pointer-events: none;
      border-radius: 1.5rem;
    }
  }
  .right {
    height: 100%;
    margin-left: 5rem;
    width: 100%;
    max-width: 600px;
    h1 {
      font-size: 4.5rem;
      margin-bottom: 2rem;
    }
    h2 {font-size: 2.5rem;}
    @media screen and (max-width: 1110px) {
      margin-left: 0;
      max-width: 500px;
      h1, h2 {text-align: center;}
      h1 {margin-bottom: 0;}
      p {margin-bottom: 2rem;}
    }
    @media screen and (max-width: 500px) {
      h1 {font-size: 3.5rem;}
      h2 {font-size: 2rem;}
    }
  }
`;